import React, { useState } from "react";
import FilterIndustries from "../partials/actions/FilterIndustries";
import AddEditOrganizationPopup from "../partials/dashboard/AddEditOrganizationPopup";
import IndustryTable from "../partials/dashboard/IndustryTable";
import CreateIndustries from "../partials/Industry/CreateIndustries";

function Industry() {
  const [showPopup, setShowPopup] = useState(false);
  const [industriesType, setIndustriesType] = useState('');
  const [filteredData, setFilteredData] = useState("");
  const [showModal, setShowModal] = useState(false); // State to control modal visibility

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleAdd = () => {
    // setShowPopup(true);
  };

  return (
    <>
      {/* Dashboard actions */}
            <div className=" flex justify-end mb-8">


              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-end gap-2">
                {/* Filter button */}
                <FilterIndustries
                  setIndustriesType={setIndustriesType}
                  industriesType={industriesType}
                  filteredData={filteredData}
                  setFilteredData={setFilteredData}
                />
                {/*<Datepicker />*/}
                {/* Add view button */}

                  <button
                    className="btn bg-green-500 hover:bg-green-600 text-white"
                    onClick={() => toggleModal("industry")}
                  >
                    Add Industry
                  </button>
                

              </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-12 gap-6">
              <IndustryTable
                setIndustriesType={setIndustriesType}
                industriesType={industriesType}
                filteredData={filteredData}
                setFilteredData={setFilteredData}
              />
            </div>

      {showPopup && (
        <AddEditOrganizationPopup customer={null} onClose={handleClosePopup} />
      )}

      {showModal && (
        <CreateIndustries toggleModal={toggleModal} />
      )}
    </>
  );
}

export default Industry;
